import { Answer } from "../types/answer";
import { API_BASE_URL } from '../apiBaseUrl';
import { getProblemMessage } from './problemDetails';

const API_URL = `${API_BASE_URL}/answer/`;

const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};

// Add Answer
export const addAnswer = async (answerData: any): Promise<Answer> => {
  try {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${API_URL}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json, application/problem+json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(answerData),
    });

    console.log('Add Answer response:', response);

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const errorMessage = await getProblemMessage(response, 'Failed to add answer');
      console.error('Failed to add answer:', errorMessage);
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error('Add Answer error:', error);
    throw error;
  }
};


export const deleteAnswer = async (id: string): Promise<void> => {
  try {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${API_URL}${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json, application/problem+json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorMessage = await getProblemMessage(response, 'Failed to delete answer');
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error('Error deleting answer:', error);
    throw error;
  }
};
